"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mfa = exports.getInitialValues = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _get = _interopRequireDefault(require("lodash/get"));

var _basis = require("basis");

var _hooks = require("../hooks");

var _MfaForm = require("../components/mfa-form/MfaForm");

var _types = require("../types");

var _components = require("../components");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getInitialValues = function getInitialValues(fields) {
  return fields.reduce(function (acc, field) {
    var inputFields = ['input', 'password', 'hidden', 'options', 'set'];

    if (!inputFields.includes(field.type)) {
      return acc;
    }

    if (field.type === 'set') {
      var set = field;
      return _objectSpread(_objectSpread({}, acc), getInitialValues(set.subElements));
    }

    var input = field;

    if (!input.id) {
      return acc;
    }

    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, input.id, input.htmlAttrs && input.htmlAttrs.value ? input.htmlAttrs.value : ''));
  }, {});
};

exports.getInitialValues = getInitialValues;

var Mfa = function Mfa() {
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var trackEvent = (0, _hooks.useEventTracker)();
  var errorFallbackButton = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.errorFallbackButton;
  });
  var additionalErrorMessage = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.additionalErrorMessage;
  });
  var config = (0, _get.default)(history, 'location.state.mfa');

  var _useMfa = (0, _hooks.useMfa)(),
      error = _useMfa.error,
      loading = _useMfa.loading,
      request = _useMfa.request;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
      var outcome, failure;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (request) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return request(values);

            case 4:
              outcome = _context.sent;

              if (!outcome.mfa) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", history.push(_types.Routes.mfa, outcome));

            case 7:
              failure = outcome;

              if (!failure.error) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", trackEvent({
                action: 'poi-error',
                label: 'MFA error'
              }));

            case 10:
              trackEvent({
                action: 'poi-bank-connect',
                label: 'mfa.buttonSubmit'
              });
              history.push(_types.Routes.accounts);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleGoBack = function handleGoBack() {
    // @ts-ignore
    var entries = history.entries,
        index = history.index;
    var firstMfaIndex = entries.findIndex(function (a) {
      return a.pathname === '/mfa';
    });
    history.go(firstMfaIndex - index - 1);
  };

  if (!config) {
    return null;
  }

  var initialValues = getInitialValues(config.fields);
  return /*#__PURE__*/_react.default.createElement(_basis.Container, {
    key: location.key
  }, /*#__PURE__*/_react.default.createElement(_components.Header, {
    error: error === null || error === void 0 ? void 0 : error.error,
    additionalErrorMessage: additionalErrorMessage
  }, config.title), /*#__PURE__*/_react.default.createElement(_MfaForm.MfaForm, {
    initialValues: initialValues,
    loading: loading,
    onSubmit: handleSubmit,
    onGoBack: handleGoBack,
    fields: config.fields
  }), error && errorFallbackButton);
};

exports.Mfa = Mfa;